import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateCategoryAction } from '../../../../actions/categoriesAction';

const MenuCategoryRenameDialog = ({
  category,
  openDialog,
  setOpenDialog,
  updateCategoryAction,
}) => {
  const closeDialog = () => {
    setCategoryName('');
    setOpenDialog(false);
  };

  const [categoryName, setCategoryName] = useState(category.categoryTitle);
  const [inputError, setInputError] = useState(null);

  useEffect(() => {
    if (openDialog) {
      setCategoryName(category?.categoryTitle);
    }
  }, [openDialog]);

  const submit = (event) => {
    event.preventDefault();

    if (categoryName === category.categoryTitle) {
      closeDialog();
      return;
    }

    if (!categoryName) {
      setInputError('Please enter a category name.');
      return;
    }
    if (inputError) {
      setInputError(null);
    }

    updateCategoryAction(
      category?.objectId,
      categoryName,
      category?.categoryIndex,
      category?.menuId,
      category?.productIds,
      category?.bundleIds,
    );

    closeDialog();
  };

  return (
    <Dialog
      open={openDialog}
      onClose={closeDialog}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      fullWidth
    >
      <DialogTitle id='alert-dialog-title'>Category Name</DialogTitle>
      <DialogContent>
        <form id='create-category-form' noValidate autoComplete='off' onSubmit={submit}>
          <TextField
            id='category-name'
            label='Category Name'
            placeholder='eg. Mains, Entrees'
            variant='outlined'
            fullWidth
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            InputLabelProps={{ shrink: true }}
            error={Boolean(inputError)}
            helperText={inputError}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button disableRipple onClick={closeDialog} color='default'>
          Cancel
        </Button>
        <Button disableRipple onClick={submit} color='primary' autoFocus>
          Save Category
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({ updateCategoryAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MenuCategoryRenameDialog);
